import API from "../config/api.js";

export const StockTransferService = {
  getstockTransfers(search, page = 1) {
    try {
      const response = API.get(`/api/transfer/getAll`, {
        params: {
          search: search,
          page: page,
        },
      });
      return response;
    } catch (error) {
      console.error("Error Transfer product:", error);
      throw error;
    }
  },

  getBranches() {
    return API.get("/api/inventory/branches");
  },

  getMainBranchAndStores() {
    return API.get("/api/inventory/main-branch-stores");
  },

  getMainBranchAndMainStores() {
    return API.get("/api/inventory/main-branch-main-stores");
  },

  getStores(branch_id) {
    return API.get(`/api/transfer/stores/${branch_id}`);
  },

  getProducts(branchOut, storeOut) {
    return API.get(`/api/transfer/products`, {
      params: {
        branchOut: branchOut,
        storeOut: storeOut,
      },
    });
  },

  async createTransfer(formData) {
    try {
      if (formData.status == "Completed") {
        formData["user_id"] = localStorage.getItem("userId");
        const response = await API.post("/api/transfer/create", formData);

        (formData["transaction_type"] = "STOCK_TRANSFER_IN"),
          (formData["type"] = "IN");
        formData["grn_number"] = response.data.data.code;
        await API.post("/api/transfer/createTransferComplete", formData);
        return response.data;
      } else {
        formData["user_id"] = localStorage.getItem("userId");
        const response = await API.post("/api/transfer/create", formData);
        return response.data;
      }
    } catch (error) {
      console.error("Error Transfer product:", error);
      throw error;
    }
  },

  async transferUpdate(itemCode) {
    const transfer = await API.get(`/api/transfer/findTransfer/${itemCode}`);
    const products = await API.get(
      `/api/transfer/getTransferProducts/${itemCode}`
    );
    const binData = {
      grn_number: itemCode,
      transaction_type: "STOCK_TRANSFER_INC",
      type: "IN",
      inBranch: transfer.data.data.in_branch_id,
      inStore: transfer.data.data.in_store_id,
      items: products.data.data,
      user_id: localStorage.getItem("userId"),
    };
    try {
      await API.post("/api/transfer/createTransferComplete", binData);
    } catch (error) {
      console.error("Error Transfer product:", error);
      throw error;
    }
  },

  async updateStatus(uuid) {
    try {
      return API.post(`/api/transfer/statusUpdate/${uuid}`);
    } catch (error) {
      console.error("Error Transfer status update:", error);
      throw error;
    }
  },

  async getBranchMainStore(uuid) {
    try {
      return API.get(`/api/requisitions/getMainStore/${uuid}`);
    } catch (error) {
      console.error("Error Fetch store:", error);
      throw error;
    }
  },

  async getTransferDetails(uuid) {
    try {
      const response = await API.get(`/api/transfer/info/${uuid}`);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching GRN details:", error);
      throw error;
    }
  },

  async getItemsBytransferId(transfer_id) {
    try {
      const response = await API.get(`/api/transfer/info/items/${transfer_id}`);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching items by transfer ID:", error);
      throw error;
    }
  },
};
